export const states = {
  userInfo: "userInfo",
  token: "token",
  isReady: "isReady",
  tenant: "tenant",
  loading: "loading",
  loadingType: "loadingType",
  idle: "idle",
  progress: "progress",
  expiry: "expiry",
  topMenuLabel: "tml",
  error: null
};
export const mutations = {
  setToken: "SET_TOKEN",
  setReady: "SET_READY",
  setLoading: "SET_LOADING",
  setLoadingType: "SET_LOADING_TYPE",
  setIdle: "SET_IDLE",
  setProgress: "SET_PROGRESS",
  setExpiry: "SET_EXPIRY",
  setError: "SET_ERROR",
  setTopMenuLabel: "SET_TOP_MENU_LABEL"
};
